import React from "react";

import styles from "./JobShiftPreStartView.module.css";

export default function JobShiftDocumentPlaceholderOverlay({ open, title, context, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.PreviewOverlay}>
      <div className={styles.PreviewModal}>
        <div className={styles.viewPreview}>
          <div className={styles.PreviewPlatformBar}>
            <div>
              <button className={styles.PreviewPlatformButton} onClick={onClose}>
                <svg height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
                  <path fill="currentColor" d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z" />
                </svg>
                <span>Back</span>
              </button>
            </div>
            <div className="text-muted">{title}</div>
          </div>
          <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100% - 54px)" }}>
            <span className="text-muted">
              {context && context.swmsNumber ? `${context.swmsNumber} document view` : `${title} document view`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
